export const STROLLERS_DETAIL_MENU_MORE = 'strollers-detail-menu-more';

export interface StrollerVideo {
    type: string;
    code: string;
}
